import { memo } from 'react';
import { NodeProps } from 'reactflow';
import { BaseNode } from './BaseNode';

export const IntegrationPerfexNode = memo((props: NodeProps) => {
  const getDescription = () => {
    const action = props.data.config?.action;
    const value = props.data.config?.value;

    if (!action) return 'Configure the action';

    const labels: Record<string, string> = {
      update_status: '📊 Update Status',
      update_source: '🌐 Update Source',
      assign_to: '👤 Assign To',
      mark_lost: '❌ Mark as Lost',
      mark_junk: '🗑️ Mark as Junk',
    };

    const actionLabel = labels[action] || action;
    return value ? `${actionLabel}: ${value}` : actionLabel;
  };

  return (
    <BaseNode
      {...props}
      icon="🔧"
      label="Perfex CRM"
      color="#9333ea"
      description={getDescription()}
      onDelete={props.data.onDelete}
    />
  );
});

IntegrationPerfexNode.displayName = 'IntegrationPerfexNode';
